const use = {
  WRONG_PASSWORD_FORMAT: {
    message: 'Password is too weak',
    field: 'password',
    code: 'USE_1'
  },
  CONFIRMATION_DOES_NOT_MATCH_PASSWORD: {
    message: 'Confirmation does not match password',
    field: 'password',
    code: 'USE_2'
  },
  INCORRECT_PASSWORD: {
    message: 'Incorrect password',
    field: 'password',
    code: 'USE_3'
  },
  FORBIDDEN_PASSWORD: {
    message: 'Forbidden password',
    field: 'password',
    code: 'USE_4'
  },
  USER_NOT_FOUND: {
    message: 'User not found',
    field: 'user',
    code: 'USE_5'
  },
  PASSWORD_ALREADY_SETTED: {
    message: 'Password already setted',
    field: 'user',
    code: 'USE_6'
  },
  EMAIL_ALREADY_REGISTERED: {
    message: 'E-mail already registered',
    field: 'email',
    code: 'USE_7'
  }
};

module.exports = use;
